import Splide from '@splidejs/splide'


document.addEventListener("DOMContentLoaded", function () {
    const sliderElement = document.querySelector('.referents-block__slider');
    let referents__slider;

    if (sliderElement) {
        function initializeSplide() {
            if (!referents__slider) {
                referents__slider = new Splide('.referents-block__slider', {
                    type: 'slide',
                    perPage: 2,
                    perMove: 1,
                    gap: '30px',
                    arrows: true,
                    pagination: false,
                    breakpoints: {
                        667: {
                            perPage: 1,
                            gap: '10px',
                        },
                    },
                });

                const progressBar = document.querySelector('.progress-bar__fill');

                referents__slider.on('move', function (newIndex) {
                    const totalSlides = referents__slider.Components.Slides.getLength(); // Toplam slayt sayısı
                    const slidesPerPage = referents__slider.options.perPage; // Sayfa başına gösterilen slayt sayısı
                    const totalPages = Math.ceil(totalSlides / slidesPerPage); // Toplam sayfa sayısı

                    // Geçerli sayfa numarasını hesapla
                    const currentPage = Math.floor(newIndex / slidesPerPage) + 1;

                    // Yüzdeyi hesapla
                    const percentage = Math.min((currentPage / totalPages) * 100, 100);

                    console.log(`Yeni Index: ${newIndex}, Toplam Sayfalar: ${totalPages}, Yüzde: ${percentage}`);
                    progressBar.style.width = `${percentage}%`;
                });

                referents__slider.mount();
            }
        }
        initializeSplide();
        window.addEventListener('resize', initializeSplide);
    }
});

